import api from "../services/api";

// Get all segments
export const getSegments = async (filters = {}) => {
  return api.get("/api/segments", { params: filters });
};

// Get single segment by ID
export const getSegmentById = async (segmentId) => {
  return api.get(`/api/segments/${segmentId}`);
};

// Create new segment
export const createSegment = async (segmentData) => {
  return api.post("/api/segments", segmentData);
};

// Update segment
export const updateSegment = async (segmentId, segmentData) => {
  return api.put(`/api/segments/${segmentId}`, segmentData);
};

// Delete segment
export const deleteSegment = async (segmentId) => {
  return api.delete(`/api/segments/${segmentId}`);
};

// Upload contacts from CSV
export const uploadContacts = async (segmentId, csvFile) => {
  const formData = new FormData();
  formData.append("csvFile", csvFile);
  return api.post(`/api/segments/${segmentId}/contacts/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Get contacts for a segment
export const getContacts = async (segmentId, filters = {}) => {
  return api.get(`/api/segments/${segmentId}/contacts`, { params: filters });
};

// Delete contact
export const deleteContact = async (segmentId, contactId) => {
  return api.delete(`/api/segments/${segmentId}/contacts/${contactId}`);
};

